import { UserStore } from "@Front/Stores/UserStore";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { jwtDecode } from "@Front/Utils/jwtDecodeWrapper";
import { decodeLeCoffreAccessTokenUserUid } from "@Front/Utils/accessTokenJwtClaimsHelpers";
import { safeArrayLength } from "@Front/Utils/arrayHelpers";
import { waitForCookieAvailability } from "@Front/Stores/activeOfficeStoreCookieWait";
import { LECOFFRE_ACCESS_TOKEN_COOKIE_NAME } from "@Front/Utils/lecoffreSessionCookieHelpers";

export async function refreshJwtSessionAfterOfficeSwitch(result: {
	accessToken?: string;
	refreshToken?: string;
}): Promise<void> {
	if (!result.accessToken || !result.refreshToken) {
		const errorMsg =
			"Le backend n'a pas renvoyé de nouveaux tokens JWT. Impossible de changer d'office sans mettre à jour la session.";
		LoggerService.error(`❌ ${errorMsg}`, {
			hasResult: !!result,
			resultKeys: result ? Object.keys(result) : [],
			hasAccessToken: !!result.accessToken,
			hasRefreshToken: !!result.refreshToken,
		});
		throw new Error(errorMsg);
	}

	LoggerService.info("🔄 Mise à jour des tokens JWT avec le nouvel office");
	const connected = await UserStore.instance.connect(result.accessToken, result.refreshToken);

	if (!connected) {
		const errorMsg = "Impossible de mettre à jour les tokens JWT dans les cookies.";
		LoggerService.error(`❌ ${errorMsg}`);
		throw new Error(errorMsg);
	}

	try {
		await waitForCookieAvailability(LECOFFRE_ACCESS_TOKEN_COOKIE_NAME, 500, 10);
		LoggerService.info("✅ Cookie accessToken vérifié et disponible");
	} catch (error) {
		const errorMsg = "Le cookie accessToken n'a pas été correctement mis à jour après le changement d'office.";
		LoggerService.error(`❌ ${errorMsg}`, { error });
		throw new Error(errorMsg);
	}

	const decoded = jwtDecode(result.accessToken) as Record<string, unknown>;
	LoggerService.info("🔍 Nouveau JWT décodé", {
		office_Id: decoded["office_Id"],
		userId: decodeLeCoffreAccessTokenUserUid(result.accessToken),
		rulesCount: safeArrayLength(decoded["rules"]),
	});

	LoggerService.info("✅ Tokens JWT mis à jour dans les cookies");
}
